import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from "@sentry/react";
import { UserStatusProvider } from './contexts/UserStatusContext';
import { UserProfileProvider } from './contexts/UserProfileContext';
import { DebugProvider } from './contexts/DebugContext';

const clientId = '233120461235-t8h4a26lp37m129r0cs479sk4pd1df00.apps.googleusercontent.com';

// Initialize Sentry
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV || 'development',
  tracesSampleRate: 1.0,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={({ error, resetError }) => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Something went wrong</h2>
      <p>We're sorry, but something unexpected happened.</p>
      <button onClick={resetError}>Try again</button>
    </div>
  )}>
    <GoogleOAuthProvider clientId={clientId}>
      <DebugProvider>
        <UserStatusProvider>
          <UserProfileProvider>
            <App />
          </UserProfileProvider>
        </UserStatusProvider>
      </DebugProvider>
    </GoogleOAuthProvider>
  </Sentry.ErrorBoundary>
);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
